import http from '../../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/salesamplelist',
    selectPage(query) {
        return http({
            url: this.baseurl + '/bscSalesSamplelistF/selectPage',
            method: 'post',
            params: query
        });
    },
    selectById(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistF/selectById?id=' + v);
    },
    updateById(query) {
        return http({
            url: this.baseurl + '/bscSalesSamplelistF/updateById',
            method: 'post',
            data: query
        });
    },
    toDelete(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistF/toDelete?id=' + v);
    },
    Listed(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistF/Listed?id=' + v);
    },
    below(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistF/below?id=' + v);
    },
    showprocategory(v){
        return http.post('/api/swyl/v1/productlevel/productLevel/showprocategory?id='+ v);
    },
    saveS(query){
        return http({
            url: this.baseurl + '/bscSalesSamplelistF/insert',
            method: 'post',
            params: query
        });
    },
    selectUpdate(v){
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistLog/selectUpdate?id='+ v);
    },
    selectModel(v) {
        return http.post('/api/swyl/v1/salesamplelist/bscSalesSamplelistF/selectModel?prodcode=' + v);
    },
}
